import { Controller } from "@hotwired/stimulus";

// `indeterminate` is a JS-only property on a checkbox — there is no HTML
// attribute for it — so a step that's started but not finished (a passport
// received but not yet released) needs this to render as a dash rather than
// as plain unchecked.
export default class extends Controller {
  connect() {
    this.element.indeterminate = this.element.dataset.indeterminate === "true";
  }
}
